import { lazy, Suspense } from 'react';
import { Skeleton } from '../ui/AsyncBoundary';

/**
 * The map, loaded on demand.
 *
 * MapLibre and its stylesheet are most of this app's JavaScript weight, and
 * three of the nine screens never show a map. Splitting it here rather than at
 * each call site means every `import { FleetMap }` gets the lazy version for
 * free and no page has to remember to do it.
 */
const FleetMapImpl = lazy(() =>
  import('./FleetMapImpl').then((module) => ({ default: module.FleetMap }))
);

export function FleetMap({ height = 420, className = '', ...props }) {
  // Every prop, including `route`, is forwarded untouched — the lazy wrapper
  // exists to split the bundle, not to have an opinion about the map's API.
  return (
    <Suspense
      fallback={
        <Skeleton
          className={`w-full rounded-xl ${className}`}
          // Same height as the real map, so the page does not jump when it arrives.
          style={{ height }}
        />
      }
    >
      <FleetMapImpl height={height} className={className} {...props} />
    </Suspense>
  );
}
